import React from "react";
import { Routes, Route } from "react-router-dom";
import LandingPage from "./features/landing/LandingPage";
import PrivacyPolicyPage from "./features/landing/components/PrivacyPolicyPage";
import TermsPage from "./features/landing/components/TermsPage";
import AboutPage from "./features/landing/components/AboutPage";
import BlogPage from "./features/landing/components/BlogPage";
import AuthPage from "./features/auth/AuthPage";
import DashboardPage from "./features/dashboard/DashboardPage";
import AnalyzePage from "./features/dashboard/AnalyzePage";
import ScoringGuidePage from "./features/dashboard/ScoringGuidePage";
import HistoryPage from "./features/dashboard/HistoryPage";
import SubscriptionPage from "./features/dashboard/SubscriptionPage";
import ProfilePage from "./features/dashboard/ProfilePage";
import DashboardLayout from "./components/layout/DashboardLayout";
import ProtectedRoute from "./features/auth/components/ProtectedRoute";
import AdminLayout from "./features/admin/layout/AdminLayout";
import ProtectedAdminRoute from "./features/admin/ProtectedAdminRoute";
import AdminOverviewPage from "./features/admin/pages/AdminOverviewPage";
import AdminUserManagementPage from "./features/admin/pages/AdminUserManagementPage";
import AdminPricingManagementPage from "./features/admin/pages/AdminPricingManagementPage";
import AdminEnterpriseContactsPage from "./features/admin/pages/AdminEnterpriseContactsPage";
import AdminPaymentHistoryPage from "./features/admin/pages/AdminPaymentHistoryPage";
import AdminTestimonialsPage from "./features/admin/pages/AdminTestimonialsPage";
import AdminProfilePage from "./features/admin/pages/AdminProfilePage";
import AdminReportsPage from "./features/admin/pages/AdminReportsPage";
import AdminFeedbackPage from "./features/admin/pages/AdminFeedbackPage";
import AdminPoliciesPage from "./features/admin/pages/AdminPoliciesPage";
import AdminAnalysisCooldownPage from "./features/admin/pages/AdminAnalysisCooldownPage";
import FeedbackPage from "./features/dashboard/FeedbackPage";
import ChangeReportPage from "./features/dashboard/ChangeReportPage";
import SubscriptionVerificationDemo from "./components/demo/SubscriptionVerificationDemo";

const AppRouter = () => (
  <Routes>
    <Route path="/" element={<LandingPage />} />
    <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
    <Route path="/terms" element={<TermsPage />} />
    <Route path="/about" element={<AboutPage />} />
    <Route path="/blog" element={<BlogPage />} />
    <Route path="/auth/login"    element={<AuthPage defaultMode="login" />} />
    <Route path="/auth/register" element={<AuthPage defaultMode="register" />} />

    {/* Dashboard routes — require a valid auth token */}
    <Route
      path="/dashboard"
      element={
        <ProtectedRoute>
          <DashboardLayout>
            <DashboardPage />
          </DashboardLayout>
        </ProtectedRoute>
      }
    />
    <Route
      path="/analyze"
      element={
        <ProtectedRoute>
          <DashboardLayout>
            <AnalyzePage />
          </DashboardLayout>
        </ProtectedRoute>
      }
    />
    <Route
      path="/history"
      element={
        <ProtectedRoute>
          <DashboardLayout>
            <HistoryPage />
          </DashboardLayout>
        </ProtectedRoute>
      }
    />
    {/* <Route
      path="/change-report"
      element={
        <ProtectedRoute>
          <DashboardLayout>
            <ChangeReportPage />
          </DashboardLayout>
        </ProtectedRoute>
      }
    /> */}
    <Route
      path="/scoring-guide"
      element={
        <ProtectedRoute>
          <DashboardLayout>
            <ScoringGuidePage />
          </DashboardLayout>
        </ProtectedRoute>
      }
    />
    <Route
      path="/subscription"
      element={
        <ProtectedRoute>
          <DashboardLayout>
            <SubscriptionPage />
          </DashboardLayout>
        </ProtectedRoute>
      }
    />
    <Route
      path="/profile"
      element={
        <ProtectedRoute>
          <DashboardLayout>
            <ProfilePage />
          </DashboardLayout>
        </ProtectedRoute>
      }
    />
    <Route
      path="/feedback"
      element={
        <ProtectedRoute>
          <DashboardLayout>
            <FeedbackPage />
          </DashboardLayout>
        </ProtectedRoute>
      }
    />

    {/* Admin routes — role: admin only */}
    <Route
      path="/admin"
      element={
        <ProtectedAdminRoute>
          <AdminLayout><AdminOverviewPage /></AdminLayout>
        </ProtectedAdminRoute>
      }
    />
    <Route
      path="/admin/users"
      element={
        <ProtectedAdminRoute>
          <AdminLayout><AdminUserManagementPage /></AdminLayout>
        </ProtectedAdminRoute>
      }
    />
    <Route
      path="/admin/pricing"
      element={
        <ProtectedAdminRoute>
          <AdminLayout><AdminPricingManagementPage /></AdminLayout>
        </ProtectedAdminRoute>
      }
    />
    <Route
      path="/admin/enterprise-contacts"
      element={
        <ProtectedAdminRoute>
          <AdminLayout><AdminEnterpriseContactsPage /></AdminLayout>
        </ProtectedAdminRoute>
      }
    />
    <Route
      path="/admin/payment-history"
      element={
        <ProtectedAdminRoute>
          <AdminLayout><AdminPaymentHistoryPage /></AdminLayout>
        </ProtectedAdminRoute>
      }
    />
    <Route
      path="/admin/testimonials"
      element={
        <ProtectedAdminRoute>
          <AdminLayout><AdminTestimonialsPage /></AdminLayout>
        </ProtectedAdminRoute>
      }
    />
    <Route
      path="/admin/profile"
      element={
        <ProtectedAdminRoute>
          <AdminLayout><AdminProfilePage /></AdminLayout>
        </ProtectedAdminRoute>
      }
    />
    <Route
      path="/admin/reports"
      element={
        <ProtectedAdminRoute>
          <AdminLayout><AdminReportsPage /></AdminLayout>
        </ProtectedAdminRoute>
      }
    />
    <Route
      path="/admin/feedback"
      element={
        <ProtectedAdminRoute>
          <AdminLayout><AdminFeedbackPage /></AdminLayout>
        </ProtectedAdminRoute>
      }
    />
    <Route
      path="/admin/policies"
      element={
        <ProtectedAdminRoute>
          <AdminLayout><AdminPoliciesPage /></AdminLayout>
        </ProtectedAdminRoute>
      }
    />
    <Route
      path="/admin/analysis-cooldown"
      element={
        <ProtectedAdminRoute>
          <AdminLayout><AdminAnalysisCooldownPage /></AdminLayout>
        </ProtectedAdminRoute>
      }
    />

    {/* Catch-all 404 */}
    {/* Demo route for testing subscription verification card */}
    <Route path="/demo/subscription-verification" element={<SubscriptionVerificationDemo />} />

    <Route
      path="*"
      element={
        <div className="min-h-screen flex items-center justify-center bg-surface">
          <div className="text-center">
            <p className="text-6xl font-extrabold text-primary mb-4">404</p>
            <p className="text-brand-muted mb-6">Page not found.</p>
            <a href="/" className="text-primary font-medium hover:underline">Go home</a>
          </div>
        </div>
      }
    />
  </Routes>
);

export default AppRouter;
